export function EmailValidationError(emailid) {
  let regex = new RegExp(
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
  return !regex.test(emailid);
}

export function userNameValidationError(userName) {
  let regex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;

  if (regex.test(userName)) {
    // contains extra characters
    return true;
  } else {
    return false;
  }
}
